/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { textPostTextAnalyze } from "../../funcs/textPostTextAnalyze.js";
import { PostTextAnalyzeRequest$zodSchema } from "../../models/posttextanalyzeop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostTextAnalyzeRequest$zodSchema,
};

export const tool$textPostTextAnalyze: ToolDefinition<typeof args> = {
  name: "text-post-text-analyze",
  description: `文本分析

想知道一篇文章有多少字、多少个词、或者多少行？这个接口可以帮你快速统计。

## 功能概述
你提供一段文本，我们会从多个维度进行分析，并返回其字符数、词数、句子数、段落数和行数。这对于文本编辑、内容管理等场景非常有用。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await textPostTextAnalyze(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
